export default {
  scrollContainer: 'overflow-auto h-[calc(100vh-10px)]',
  loaderContainer: 'loader-container',
  emptyContainer: 'empty-container',
  emptyText: 'empty-text',
  cardListContainer: 'm-2 mt-[58px]',
  startTitle: 'text-[16px]! font-medium! truncate w-[300px]',
  activeContent: 'bg-[#9ACC9A]!',
  inactiveContent: 'bg-[#EFCCD2]!',
  cardContent: 'cursor-pointer',
  row: 'flex justify-between',
  key: 'text-sm font-medium text-[#00000099]',
  value: 'text-sm',
};
